<template>
  <div
    class="question-form-category">
    <div
      class="cat-title title font-weight-bold">
      {{ category.label }}
    </div>
    <Question
      v-for="question in questionsToRender"
      :key="question.key"
      render-as-form-field
      :question="question"
      :readonly="readonly"
      :answer="getAnswerForQuestion(question)"
      @update-answer="onUpdateAnswer"
      @update-answer-verification="onUpdateAnswerVerification" />
  </div>
</template>

<script>
import Question from './Question'
import BL from '@/bl/bl'

export default {
  name: 'QuestionFormCategory',

  components: {
    Question
  },

  props: {
    category: {
      type: Object,
      default: void 0,
      required: true
    },

    answers: {
      type: Array,
      default: void 0,
      required: true
    },

    readonly: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    questions () {
      return BL.getAllQuestions()
    },

    questionsToRender () {
      return BL.getQuestionsToRenderForCategory(this.category, this.answers)
    }
  },

  methods: {
    getAnswerForQuestion (question) {
      return BL.getAnswerForQuestion(question, this.answers)
    },

    onUpdateAnswer (value, question, answer) {
      BL.updateAnswerWithValue(question, answer, value, this.questions, this.answers)
      this.$emit('change-answer')
    },

    onUpdateAnswerVerification (status, comment, question, answer) {
      BL.updateAnswerVerification(question, answer, status, comment, this.answers)
      this.$emit('change-answer')
    }
  }
}
</script>

<style lang="scss">
  .question-form-category {
    .cat-title {
      color: black;
      margin-top: 1em;
      margin-bottom: 2em;
    }
  }
</style>
